import { useState, useEffect } from 'react';
import { getAplicacionValueById } from '../../utils/AplicacionesUtils';

export default function ConditionalSelectComponent({ props, setValue, register, watch }) {

    const [listOpt, setListOpt] = useState([]);

    // Observar el valor del campo del que depende (ahora con LookupId porque aplicacion_busint es tipo lookup)
    const dependsOnValue = watch ? watch(props.dependsOn + 'LookupId') : null;

    useEffect(() => {
        // Registrar el campo con validación si es requerido
        const registerOptions = props.required ? { required: true } : {};
        register(props.name, registerOptions);
    }, [register, props.name, props.required]);

    useEffect(() => {
        if (dependsOnValue) {
            // Obtener la aplicación seleccionada basándose en el ID
            const selectedApp = getAplicacionValueById(dependsOnValue);

            // Si la aplicación tiene opciones condicionales definidas, cargarlas
            if (props.conditionalChoices && props.conditionalChoices[selectedApp]) {
                const options = props.conditionalChoices[selectedApp];
                setListOpt(options);

                // Limpiar selección actual cuando cambia la aplicación
                setValue(props.name, '', { shouldValidate: false });
            } else {
                // Para aplicaciones sin opciones condicionales, usar el mismo nombre de la aplicación
                setListOpt([selectedApp]);

                // Establecer automáticamente el valor
                setValue(props.name, selectedApp, { shouldValidate: true });
            }
        } else {
            setListOpt([]);
            setValue(props.name, '', { shouldValidate: false });
        }
    }, [dependsOnValue, props.conditionalChoices, props.name, setValue]);

    const selectProps = {
        name: props.name,
        id: props.id,
        ...register(props.name, {
            ...(props.required ? { required: true } : {})
        })
    };

    return (
        props.hidden ? null :
            <div>
                <label htmlFor={props.id}>
                    {props.displayName}
                    <span>{props.description}</span>
                </label>
                <select {...selectProps} disabled={listOpt.length === 0}>
                    <option value="" key={props.id + 'empty'}>
                        {listOpt.length === 0 ? 'Selecciona primero una aplicación' : ''}
                    </option>
                    {listOpt.map((item, index) => (
                        <option value={item} key={props.id + '__' + index}>
                            {item}
                        </option>
                    ))}
                </select>
                {props.required && <span className='error-message'>Debes elegir {props.displayName}</span>}
            </div>
    );
}
